import _ from 'lodash'
import { useFormContext, useWatch } from 'react-hook-form'

import { useLevelPlaySurface } from '@/shared/level-play'



export const LevelPlayMosaic = ({ activity }) => {
  const { isSubmitting, answerIsRight, answerIsWrong, disableInputs } =
    useLevelPlaySurface()
  const { meta } = activity
  const images = _.get(meta, 'images', [])
  const { setValue } = useFormContext()
  const watchAnswer = useWatch({ name: 'answer', defaultValue: [] })

  const toggleSelectImageId = imageId => {
    if (isSubmitting || disableInputs) return

    const newAnswer = watchAnswer.includes(imageId)
      ? watchAnswer.filter(id => id !== imageId)
      : [...watchAnswer, imageId]

    setValue('answer', newAnswer)
  }

  return (
    <div className="grid gap-2 w-full mx-auto grid-cols-2 [&>*]:aspect-square">
      {images.map((image, index) => {
        const imageId = _.get(image, 'image_id')
        const isSelected = (watchAnswer || []).includes(imageId)
        let borderColor = 'border-gray-200'
        if (answerIsRight && isSelected) {
          borderColor = 'border-success'
        } else if (answerIsWrong && isSelected) {
          borderColor = 'border-danger'
        } else if (isSelected) {
          borderColor = 'border-primary'
        }

        return (
          <div
            key={`image-${index}`}
            className={`overflow-hidden border border-3 rounded-xl cursor-pointer ${borderColor}`}
            onClick={() => toggleSelectImageId(imageId)}
          >
            <img
              src={_.get(image, 'image.file.url')}
              alt={image?.name || ''}
              className="object-cover object-center bg-white block w-full h-full"
              style={{ pointerEvents: 'none' }}
            />
          </div>
        )
      })}
    </div>
  )
}
